export const GRID_TEMPLATES = {
  HEALTHCARE_WITH_MEDICAL: '6fr 6fr 4fr 1fr',
  WITH_SALES_AREA: '6fr 6fr 4fr 4fr',
  DEFAULT: '6fr 6fr 4fr',
} as const

export const SPECIAL_CATEGORIES = {
  MULLIEZ_SUFFIX: '_mulliez',
  HEALTHCARE_UNIT: 'healthcare_unit',
} as const

export const headers = [{
  label: 'address',
  name: 'address',
  type: 'text',
  sortable: true,
  filter: {
    enabled: true,
    clearable: true,
  },
},
{
  label: 'brand',
  name: 'brand',
  type: 'checkbox',
  sortable: true,
  filter: {
    enabled: true,
    clearable: true,
    checkboxes: true,
  },
},
{
  label: 'category',
  name: 'category',
  type: 'category',
  sortable: true,
  filter: {
    enabled: true,
    clearable: true,
    checkboxes: true,
  },
},
]
